import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.base`;
export const PERSIST_STATE = `${SCOPE}/PERSIST_STATE`;

const types = {
  INIT: `${SCOPE}/INIT`,
  SET_DATE: `${SCOPE}/SET_DATE`,
  SET_INTERVAL: `${SCOPE}/SET_INTERVAL`,
  SET_ADVANCED: `${SCOPE}/SET_ADVANCED`,
  SET_ROWDATA: `${SCOPE}/SET_ROWDATA`,
  SET_GEODATA: `${SCOPE}/SET_GEODATA`,
  SET_SEARCH_SORT_DATA: `${SCOPE}/SET_SEARCH_SORT_DATA`,
  SET_ENABLESSE: `${SCOPE}/SET_ENABLESSE`,
  RESET_SEARCH_SORT: `${SCOPE}/RESET_SEARCH_SORT`,
  SET_TABLE_COLUMNS: `${SCOPE}/SET_TABLE_COLUMNS`,
  SET_SELECTED_COLUMNS: `${SCOPE}/SET_SELECTED_COLUMNS`,
  SET_ANCHORED_COLUMNS: `${SCOPE}/SET_ANCHORED_COLUMNS`,
  UPDATE_SELECTED_METRICS: `${SCOPE}/UPDATE_SELECTED_METRICS`,
  UPDATE: `${SCOPE}/UPDATE`,
  SET_ADVANCED_TOGGLE: `${SCOPE}/SET_ADVANCED_TOGGLE`,
};

export default types;
